import React from 'react';
import { connect } from 'react-redux';
// import { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert'
import { clearMessageDisplay } from './actions'
import './MessageDisplay.css';

const MessageDisplay = ({ userInfo, reviewInfo, startClearMessageDisplay }) => {
  let content = '';
  if (reviewInfo.message) {
    setTimeout(() => {
      console.log('Time it up for message display');
      startClearMessageDisplay();
    }, 10000);
    content = 
      <Alert variant="success" onClose={() => startClearMessageDisplay()} dismissible>
        <div className="message-content">{reviewInfo.message}</div>
      </Alert>
  }
  return content;
}

const mapState = state => ({
  reviewInfo: state.reviewInfo,
  userInfo: state.userInfo,
})

const mapDispatch = dispatch => ({
  // setFileAttribute: (param) => dispatch(setOutputFileAttribute(param)),
  startClearMessageDisplay: () => dispatch(clearMessageDisplay()),
})

export default connect(mapState, mapDispatch)(MessageDisplay);
